import { IconSVGProps } from '../types'

export const MedalIcon = ({ className, fill }: IconSVGProps) => (
  <svg
    className={className}
    width="10"
    height="10"
    viewBox="0 0 10 10"
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
  >
    <path d="M4.97977 3.26003C5.70115 3.26003 6.393 3.5466 6.9031 4.0567C7.4132 4.5668 7.69977 5.25864 7.69977 5.98003C7.69977 6.70142 7.4132 7.39326 6.9031 7.90336C6.393 8.41346 5.70115 8.70003 4.97977 8.70003C4.25838 8.70003 3.56653 8.41346 3.05644 7.90336C2.54634 7.39326 2.25977 6.70142 2.25977 5.98003C2.25977 5.25864 2.54634 4.5668 3.05644 4.0567C3.56653 3.5466 4.25838 3.26003 4.97977 3.26003V3.26003ZM4.97977 4.45003L4.52995 5.36123L3.52457 5.50743L4.25217 6.21633L4.08047 7.21797L4.97977 6.74503L5.87907 7.21763L5.70737 6.21633L6.43497 5.50709L5.42959 5.36089L4.97977 4.45003ZM5.31977 1.55969L7.01977 1.56003V2.58003L6.55635 2.96695C6.17179 2.76519 5.75193 2.63948 5.31977 2.59669V1.56003V1.55969ZM4.63977 1.55969V2.59669C4.20774 2.63941 3.78801 2.76501 3.40353 2.96661L2.93977 2.58003V1.56003L4.63977 1.55969V1.55969Z" />
  </svg>
)
